var _ellipse, _g, _g2, _g3, _rect, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 113,
    viewBox: "0 0 164 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.05,
    cx: 78.076,
    cy: 49.7488,
    rx: 78.076,
    ry: 49.7488,
    transform: "matrix(-0.915086 -0.403258 -0.403298 0.915069 173.52 42.9695)",
    fill: "#72A4FC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2414_21178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 19,
    width: 116,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.75,
    y: 19.25,
    width: 115.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 25,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5996 29.55C65.5996 28.9978 65.1519 28.55 64.5996 28.55H49.5996C49.0473 28.55 48.5996 28.9978 48.5996 29.55V32.55C48.5996 33.1023 49.0473 33.55 49.5996 33.55H64.5996C65.1519 33.55 65.5996 33.1023 65.5996 32.55V29.55Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.6 29.55C107.6 28.9978 107.152 28.55 106.6 28.55H70.5996C70.0473 28.55 69.5996 28.9978 69.5996 29.55V32.55C69.5996 33.1023 70.0473 33.55 70.5996 33.55H106.6C107.152 33.55 107.6 33.1023 107.6 32.55V29.55Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.6 29.55C122.6 28.9978 122.152 28.55 121.6 28.55H112.6C112.047 28.55 111.6 28.9978 111.6 29.55V32.55C111.6 33.1023 112.047 33.55 112.6 33.55H121.6C122.152 33.55 122.6 33.1023 122.6 32.55V29.55Z",
    fill: "#CECECE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_2414_21178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 47.1,
    width: 116,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.75,
    y: 47.35,
    width: 115.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 53.1,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5996 57.65C77.5996 57.0977 77.1519 56.65 76.5996 56.65H49.5996C49.0473 56.65 48.5996 57.0977 48.5996 57.65V60.65C48.5996 61.2023 49.0473 61.65 49.5996 61.65H76.5996C77.1519 61.65 77.5996 61.2023 77.5996 60.65V57.65Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5996 57.65C93.5996 57.0977 93.1519 56.65 92.5996 56.65H82.5996C82.0473 56.65 81.5996 57.0977 81.5996 57.65V60.65C81.5996 61.2023 82.0473 61.65 82.5996 61.65H92.5996C93.1519 61.65 93.5996 61.2023 93.5996 60.65V57.65Z",
    fill: "#CECECE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.6 57.65C114.6 57.0977 114.152 56.65 113.6 56.65H98.5996C98.0473 56.65 97.5996 57.0977 97.5996 57.65V60.65C97.5996 61.2023 98.0473 61.65 98.5996 61.65H113.6C114.152 61.65 114.6 61.2023 114.6 60.65V57.65Z",
    fill: "#CECECE"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2414_21178)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 75.2,
    width: 116,
    height: 24.1,
    rx: 4,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.75,
    y: 75.45,
    width: 115.5,
    height: 23.6,
    rx: 3.75,
    stroke: "#F2F2F2",
    strokeWidth: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.5,
    y: 81.2,
    width: 12.1,
    height: 12.1,
    rx: 6.05,
    fill: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5996 85.75C66.5996 85.1977 66.1519 84.75 65.5996 84.75H49.5996C49.0473 84.75 48.5996 85.1977 48.5996 85.75V88.75C48.5996 89.3023 49.0473 89.75 49.5996 89.75H65.5996C66.1519 89.75 66.5996 89.3023 66.5996 88.75V85.75Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5996 85.75C99.5996 85.1977 99.1519 84.75 98.5996 84.75H71.5996C71.0473 84.75 70.5996 85.1977 70.5996 85.75V88.75C70.5996 89.3023 71.0473 89.75 71.5996 89.75H98.5996C99.1519 89.75 99.5996 89.3023 99.5996 88.75V85.75Z",
    fill: "#E7E7E7"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 52.5,
    y: 27,
    width: 60,
    height: 60,
    rx: 30,
    fill: "#C4D9FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 51L78 66L70.5 59.1818",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.564 85.8571L131.961 86.3116C129.747 86.9392 127.443 85.6531 126.816 83.4392C126.188 81.2252 127.474 78.9217 129.688 78.2942L131.292 77.8396M138.375 84.4936L139.978 84.0391C142.192 83.4116 143.478 81.1081 142.851 78.8941C142.223 76.6801 139.92 75.3941 137.706 76.0216L136.102 76.4761M130.825 82.3029L138.842 80.0304",
    stroke: "#C4D9FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6351 20.3816L27.4101 19.4511C24.338 18.1664 22.8891 14.6345 24.1738 11.5625C25.4585 8.4904 28.9904 7.04148 32.0625 8.3262L34.2875 9.25668M36.31 23.1731L38.535 24.1036C41.6071 25.3883 45.139 23.9393 46.4237 20.8673C47.7084 17.7952 46.2595 14.2633 43.1874 12.9786L40.9624 12.0481M29.7363 13.8887L40.8612 18.5411",
    stroke: "#C4D9FE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2414_21178",
    x: 20.5,
    y: 19,
    width: 124,
    height: 32.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2414_21178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2414_21178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2414_21178",
    x: 20.5,
    y: 47.1,
    width: 124,
    height: 32.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2414_21178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2414_21178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2414_21178",
    x: 20.5,
    y: 75.2,
    width: 124,
    height: 32.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0 0.720833 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2414_21178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2414_21178",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.1fe0667e.svg";
export { ForwardRef as ReactComponent };